import { Article, getArticleId } from '@opoint/infomedia-storybook'
import { useIdenticalArticlesContext } from '../context/identicalArticlesContext'


export const useIdenticalArticles = (
  article: Article | undefined,
): {
  hasIdenticalArticles: boolean
  identicalArticles: Article[]
  activeArticle: Article
  activeArticleIndex: number
  setActiveArticleIndex: (index: number) => void
  setNextActiveArticle: () => void
  setPrevActiveArticle: () => void
} => {
  const { identicalArticlesActiveIndexes, setActiveIdenticalArticleIndex } =
    useIdenticalArticlesContext()

  if (!article) {
    return {
      hasIdenticalArticles: false,
      identicalArticles: [],
      activeArticle: {} as Article,
      activeArticleIndex: 0,
      setActiveArticleIndex: () => {},
      setNextActiveArticle: () => {},
      setPrevActiveArticle: () => {},
    }
  }

  const { identical_documents } = article

  const hasIdenticalArticles =
    !!identical_documents?.cnt && identical_documents.cnt > 0

  const identicalArticles = [
    article,
    ...(hasIdenticalArticles ? identical_documents.document : []),
  ] as Article[]

  const activeArticleIndex =
    identicalArticlesActiveIndexes[getArticleId(article)] || 0

  const activeArticle = identicalArticles[activeArticleIndex]

  const setActiveArticleIndex = (index: number) => {
    setActiveIdenticalArticleIndex(getArticleId(article), index)
  }

  const setNextActiveArticle = () => {
    setActiveArticleIndex((activeArticleIndex + 1) % identicalArticles.length)
  }

  const setPrevActiveArticle = () => {
    setActiveArticleIndex(
      (activeArticleIndex - 1 + identicalArticles.length) %
        identicalArticles.length,
    )
  }

  return {
    hasIdenticalArticles,
    identicalArticles,
    activeArticleIndex,
    activeArticle,
    setActiveArticleIndex,
    setNextActiveArticle,
    setPrevActiveArticle,
  }
}

